export const ensureSidebarIsClosed = () => {
  const backButton = document.querySelector(
    "div[class*=Sidebar_container] [class*=EntityRecordView_back] .mmc-button"
  );
  if (backButton) {
    (backButton as HTMLElement).click();
  }

  // now we need time to react to process our click before we proceed with another click
  setTimeout(() => {
    const sidebarClose = document.querySelector(
      "div[class*=Sidebar_container] span[class*=anticon-close]"
    );
    if (sidebarClose) {
      (sidebarClose as HTMLElement).click();
    }
  }, 100);
};
